import React from 'react';
import { FormModal } from '../../../../components/containers/FormModal';
import { Input } from '../../../../components/forms/Input';
import { UseFormReturn } from 'react-hook-form';
import { InputTypes } from '../../../../constants/form';
import { SelectOrType } from '../../../../components/forms/SelectOrType';
import { UtmInput } from '../../../../models/graphql';
import { SelectItem } from '../../../../components/forms/Select/Select.view';
import { OptionalUtmInput } from '../../../PostEditor/LinkEditModal/StagedLinkActions';

export type EditUtmModalViewProps = {
  onClose: () => void;
  onSubmit: (data: { source: string; medium: string; campaign: string; term: string; content: string }) => void;
  submitted: boolean;
  useFormInstance: UseFormReturn;
  submitCallback?: (input: OptionalUtmInput) => void;
  disabledFields?: Array<keyof UtmInput>;
};

const DEFAULT_UTM_OPTIONS: SelectItem[] = [
  { label: 'NETWORK', value: 'NETWORK' },
  { label: 'ACCOUNT', value: 'ACCOUNT' },
  { label: 'CATEGORY', value: 'CATEGORY' }
];
export const EditUtmModalView = (props: EditUtmModalViewProps): JSX.Element => {
  const { onClose, submitted, useFormInstance, onSubmit, disabledFields } = props;
  return (
    <FormModal
      onClose={onClose}
      showCloseIcon={!submitted}
      formInstance={useFormInstance}
      loading={submitted}
      onSubmit={onSubmit}
      submitText={'Save UTM Parameters'}
      title={'Default UTM Parameters'}>
      <div className={`padding-bottom-small-32`}>
        <p>
          By default, any new links you add to a Post will have the following UTM parameters added automatically.
          <br />
          You can type your own text, or else choose from our template tags, which will dynamically insert the platform,
          profile name, or category name.
        </p>
        <ul>
          <li>NETWORK - e.g. Facebook, X (Twitter)</li>
          <li>ACCOUNT - e.g. John Smith, johnsmith</li>
          <li>CATEGORY - e.g. Blog Posts, Articles</li>
        </ul>
        <p>
          You are advised to keep Campaign Medium set to &apos;social&apos;, as this helps Google Analytics detect
          social traffic.
        </p>
        <p>
          Read more:{' '}
          <a href={'http://blog.rafflecopter.com/2014/04/utm-naming-conventions/'} target={'_blank'} rel={'noreferrer'}>
            6 tips on naming UTM parameters
          </a>{' '}
        </p>
      </div>

      <div className={`padding-bottom-small-20`}>
        <SelectOrType
          placeholder={'Type or select the Source'}
          disabled={submitted || !!disabledFields?.includes('source')}
          name={'source'}
          label={'Campaign Source'}
          formInstance={useFormInstance}
          items={DEFAULT_UTM_OPTIONS}
          size={'large'}
          rules={{}}
        />
      </div>
      <div className={`padding-bottom-small-20`}>
        <SelectOrType
          placeholder={'Type or select the Medium'}
          disabled={submitted || !!disabledFields?.includes('medium')}
          name={'medium'}
          label={'Campaign Medium'}
          formInstance={useFormInstance}
          items={DEFAULT_UTM_OPTIONS}
          size={'large'}
          rules={{}}
        />
      </div>
      <div className={`padding-bottom-small-20`}>
        <SelectOrType
          placeholder={'Type or select the Name'}
          disabled={submitted || !!disabledFields?.includes('campaign')}
          name={'campaign'}
          label={'Campaign Name'}
          formInstance={useFormInstance}
          items={DEFAULT_UTM_OPTIONS}
          size={'large'}
          rules={{}}
        />
      </div>
      <div className={`padding-bottom-small-20`}>
        <Input
          disabled={submitted || !!disabledFields?.includes('term')}
          formInstance={useFormInstance}
          name={'term'}
          type={InputTypes.text}
          size={'large'}
          label={'Campaign Term'}
          rules={{}}
        />
      </div>
      <div>
        <SelectOrType
          placeholder={'Type or select the Content'}
          disabled={submitted || !!disabledFields?.includes('content')}
          name={'content'}
          label={'Campaign Content'}
          formInstance={useFormInstance}
          items={DEFAULT_UTM_OPTIONS}
          size={'large'}
          rules={{}}
        />
      </div>
    </FormModal>
  );
};
